export const COGNITO_CONFIG = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID,
  ClientId: process.env.REACT_APP_API_CLIENT_ID || "",
  Region: process.env.REACT_APP_AWS_REGION || "us-east-1",
};
